
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"thumb-down"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.625 1.873a4.961 4.961 0 01-1.298-.19L11.298.817A5 5 0 009.926.625h-4.07a5 5 0 00-4.976 4.5l-.25 4.25a3.75 3.75 0 002.833 3.828l1.213.265a1.25 1.25 0 01.95 1.213V17.5a1.875 1.875 0 103.75 0v-1.295a6.25 6.25 0 016.25-6.25V1.873z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.375.625h-3.75v11.25h3.75V.625z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    